'use client';

import { useEffect } from 'react';

import { useTranslations } from '@/i18n/useTranslations';
import { useUpgradeSubscriptionPopup } from '@/lib/ui/useUpgradeSubscriptionPopup';

import PopupShell from './PopupShell';
import Spinner from '@/ui/components/Spinner';

import button from '@/styles/button.module.sass';
import divs from '@/styles/divs.module.sass';
import text from '@/styles/text.module.sass';
import styles from './index.module.sass';

export default function UpgradeSubscriptionPopup() {
  const { t } = useTranslations('Popup');
  const open = useUpgradeSubscriptionPopup((s) => s.open);
  const hide = useUpgradeSubscriptionPopup((s) => s.hide);
  const retry = useUpgradeSubscriptionPopup((s) => s.payload?.retry);

  useEffect(() => {
    if (!open || !retry) return;
    const interval = window.setInterval(retry, 3000);
    return () => window.clearInterval(interval);
  }, [open, retry]);

  return (
    <PopupShell open={open} onClose={hide}>
      <div className={divs.flexCl8}>
        <h2 className={text.h2}>{t('header')}</h2>
        <div className={divs.flex8}>
          <p className={text.p}>{t('subheader')}</p>
          <Spinner />
        </div>
      </div>
      <hr className={styles.divider} />
      <p className={text.p}>{t('upgradePlan')}</p>
      <div className={`${button.vWrapper} ${styles.actions}`}>
        <a
          className={button.accent}
          href="https://t.me/neovpn?start=cmd_update_plan_TRINITY"
          target="_blank"
          rel="noreferrer"
        >
          Trinity <span className={styles.buttonPrice}>{t('trinityPrice')}</span>
        </a>
        <a
          className={button.accent}
          href="https://t.me/neovpn?start=cmd_update_plan_MORPHEUS"
          target="_blank"
          rel="noreferrer"
        >
          Morpheus <span className={styles.buttonPrice}>{t('morpheusPrice')}</span>
        </a>
        <button className={button.secondary} onClick={hide}>
          {t('close')}
        </button>
      </div>
    </PopupShell>
  );
}
